import { getLandingPageSettings } from "../api/getLandingPageSettings";

// TEMPORARY: backend doesn't return a CDP api key yet, so it stays static.
const CDP_API_KEY = "telecdpKbjJ2lTyCwMv3Rhjt30OfKOdl7LOewOv";

export const hasConsent = () => {
  try {
    const stored = localStorage.getItem("teleforce_cdp_consent");
    if (!stored) return false;
    return JSON.parse(stored)?.adUserData === true;
  } catch {
    return false;
  }
};

export const trackClick = (elementId, extra = {}) => {
  if (!hasConsent()) return;
  window.TeleforceCDP?.trackClick(elementId, {
    category: "cta",
    src: elementId,
    pageUrl: window.location.href,
    ...extra,
  });
};

export const loadLandingTrackingScripts = async () => {
  try {
    const settings = await getLandingPageSettings();
    if (!settings) return;

    if (settings.gtm_enabled === "1" && settings.gtm_id) {
      const GTM_ID = settings.gtm_id;

      if (!window.dataLayer) window.dataLayer = [];

      if (!document.getElementById("gtm-script")) {
        const gtmScript = document.createElement("script");
        gtmScript.id = "gtm-script";
        gtmScript.innerHTML = `
          (function(w,d,s,l,i){
            w[l]=w[l]||[];
            w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
            var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
            j.async=true;
            j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
            f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${GTM_ID}');
        `;
        document.head.appendChild(gtmScript);

        const gtmNS = document.createElement("noscript");
        gtmNS.innerHTML = `
          <iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}"
          height="0" width="0" style="display:none;visibility:hidden"></iframe>
        `;
        document.body.prepend(gtmNS);
      }
    }

    if (settings.fb_pixel_enabled === "1" && settings.fb_pixel_id) {
      const FB_PIXEL_ID = settings.fb_pixel_id;

      if (!window.fbq) {
        const pixelScript = document.createElement("script");
        pixelScript.innerHTML = `
          !function(f,b,e,v,n,t,s){
            if(f.fbq)return;
            n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;
            n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];
            t=b.createElement(e);t.async=!0;
            t.src=v;
            s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)
          }(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
          fbq('init','${FB_PIXEL_ID}');
          fbq('track','PageView');
        `;
        document.head.appendChild(pixelScript);

        const pixelNS = document.createElement("noscript");
        pixelNS.innerHTML = `
          <img height="1" width="1" style="display:none"
          src="https://www.facebook.com/tr?id=${FB_PIXEL_ID}&ev=PageView&noscript=1" />
        `;
        document.body.appendChild(pixelNS);
      }
    }

    if (settings.domain_name) {
      initCdpTracker({
        tenantId: settings.domain_name,
        advertiserId: settings.account_id || settings.domain_name,
        apiKey: CDP_API_KEY,
      });
    }
  } catch (err) {
    console.error("Landing tracking failed", err);
  }
};

const initCdpTracker = ({ tenantId, advertiserId, apiKey }) => {
  const setup = () => {
    if (!window.TeleforceCDP || window.__tfCdpInitialized) return;
    window.__tfCdpInitialized = true;

    window.TeleforceCDP.init(advertiserId, {
      tenantId,
      apiKey,
      dataLayer: false,
      autoClickTracking: true,
    });

    window.TeleforceCDP.initConsentBanner({
      storageKey: "teleforce_cdp_consent",
      message:
        'Uses necessary cookies to keep the platform secure and functional. By clicking "Accept Cookies," you agree to our use of cookies to improve your experience.',
      acceptText: "Accept Cookies",
      declineText: "Decline Cookies",
      onConsent: (consent) => {
        console.log("CDP user id:", window.TeleforceCDP.getCdpUserId());

        if (consent.adUserData === true) {
          window.TeleforceCDP.initScrollTracking();

          window.TeleforceCDP.trackPageView({
            category: "product",
            pageUrl: window.location.href,
            pageTitle: document.title,
            referrer: document.referrer,
          });

          // Fingerprint this specific consent record (not just "consent exists")
          // so a fresh accept — after a decline or a cleared consent — re-fires
          // SESSION_START, while a plain page refresh on the same consent doesn't.
          const consentRaw = localStorage.getItem("teleforce_cdp_consent") || "";
          if (sessionStorage.getItem("tf_session_started") !== consentRaw) {
            sessionStorage.setItem("tf_session_started", consentRaw);
            window.TeleforceCDP.trackEvent("SESSION_START", {
              referrer: document.referrer,
              landingPage: window.location.href,
            });
          }
        } else if (!sessionStorage.getItem("tf_decline_tracked")) {
          sessionStorage.setItem("tf_decline_tracked", "1");
          window.TeleforceCDP.trackEvent("CONSENT_DECLINED", {
            pageUrl: window.location.href,
            timestamp: new Date().toISOString(),
          });
        }
      },
    });
  };

  if (window.TeleforceCDP) {
    setup();
  } else {
    window.addEventListener("load", setup, { once: true });
  }
};
